window.Snackbar = require('../lib/snackbar')

document.addEventListener('livewire:load', function() {
    window.livewire.on('snackDanger', function(text){
        Snackbar.show({
            text: text,
            actionTextColor: '#fff',
            backgroundColor: '#F34444',
            duration: 8000,
            pos: 'top-right'
        });
    });
    window.livewire.on('snackSuccess', function(text){
        Snackbar.show({
            text: text,
            actionTextColor: '#fff',
            backgroundColor: '#065A45',
            duration: 8000,
            pos: 'top-right'
        });
    });
    window.livewire.on('snackWarning', function(text){
        Snackbar.show({
            text: text,
            actionTextColor: '#fff',
            backgroundColor: '#FF9600',
            duration: 8000,
            pos: 'top-right'
        });
    });
})
